// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1686921143722
      var cssReload = require("C:/Users/golyashov/Documents/IT/yuvin/assets/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  